import {
	type FetchUserTransactionHistorySummaryByTypeParams,
	type FetchUserTransactionHistorySummaryLastByTypeParams
} from '@capsicum/common';
import { type RequestParams } from 'libs/common/services/api/__generated/http-client';

import { walletApi } from '.';

export async function fetchUserTransactionHistorySummaryByType(params: FetchUserTransactionHistorySummaryByTypeParams) {
	return (await walletApi).fetchUserTransactionHistorySummaryByType(params);
}

export async function fetchUserTransactionHistoryByTransactionId(transactionId: string, params: RequestParams = {}) {
	return (await walletApi).fetchUserTransactionHistoryByTransactionId(transactionId, params).then(res => res.data);
}

export async function fetchUserTransactionHistorySummaryLastByType(
	params: FetchUserTransactionHistorySummaryLastByTypeParams
) {
	return (await walletApi)
		.fetchUserTransactionHistorySummaryLastByType({
			limit: 10,
			...params
		})
		.then(res => res.data);
}
